export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";